import { Component } from 'vue-property-decorator';
import AvatarDropdown from './AvatarDropdown.vue';
import NewsUpdateButton from './NewsUpdateButton.vue';
import EditorBase from '../editor/EditorBase';

@Component({
  components: {
    AvatarDropdown,
    NewsUpdateButton,
  },
})
export default class MessageBanner extends EditorBase {

  get bannerType() {
    return this.bannerMessage.type;
  }

  get bannerData() {
    return this.bannerMessage.data;
  }

  clearMessage() {
    this.userModule.setBannerMessage(null);
  }
}
